module.exports = __webpack_public_path__ + "img/bg_festa5.0b6ccb97.jpg";